import { render, staticRenderFns } from "./AccidentRate.vue?vue&type=template&id=5edbb1ac"
import script from "./AccidentRate.vue?vue&type=script&lang=js"
export * from "./AccidentRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports